<template>

    <div class="container">

        <app-head title="Supplier Properties" />
        
        <back :href="route('admin.suppliers.index')" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Supplier Properties') }}</h1>
            <div class="">
                <!--            @todo    <inertia-link class="btn btn-primary" :href="route('admin.suppliers.properties.create', supplier)">
                                    {{ __('Create') }}
                                </inertia-link>-->
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="card">
            <data-table :items="supplierProperties"
                        :columns="columns"
                        >
                <data-table-row v-for="supplierProperty in supplierProperties" :key="supplierProperty.id">
                    <td>
                        {{ supplierProperty.id }}
                    </td>
                    <td>
                        {{ supplierProperty.name }}
                    </td>
                    <td>
                        <div class="row row-cols-4 g-1">
                            <div class="col small" v-for="dataOption in supplierProperty.data_options">
                                {{ dataOption | truncateWords() }}
                            </div>
                        </div>
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';

    import Boolean from '@/shared/Admin/Boolean';

    export default {
        props: [
            'filters',
            'supplier',
            'supplierProperties',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID'},
                    name: {label: 'Name'},
                    data_options: {label: 'Data Options'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.suppliers.properties.index', this.supplier), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>